import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { PageElement } from './Page';

const Drivemap = lazy(() =>
    import('@/v1/management/views/Drivemap/Drivemap').then((module) => ({
        default: module.Drivemap,
    }))
);
export const DrivemapRoutes: RouteObject[] = [
    {
        path: `monitor`,
        ...PageElement(<Drivemap />),
    },
];
